function isChunkLoadFailure(message, error) {
  const msg = String(message || "");
  if (msg.includes("Loading chunk") || msg.includes("ChunkLoadError")) return true;
  if (error?.name === "ChunkLoadError") return true;
  return false;
}

export function registerGlobalErrorHandlers() {
  const navigateToServerError = () => {
    window.location.href = "/Server-Error";
  };

  window.addEventListener("error", (event) => {
    console.error("Global error caught:", event.error || event.message);
    if (isChunkLoadFailure(event?.message, event?.error)) {
      console.warn(
        "Chunk load failure — navigating to /Server-Error (stale deploy or network).",
      );
      event.preventDefault();
      navigateToServerError();
    }
    // Other errors: log only — do not redirect (avoids nuking the app on minor script errors)
  });

  window.addEventListener("unhandledrejection", (event) => {
    const reason = event.reason;
    const msg = reason?.message || String(reason || "");
    console.error("Unhandled Promise rejection:", reason);
    if (isChunkLoadFailure(msg, reason)) {
      event.preventDefault();
      navigateToServerError();
    }
    // Other rejections: log only
  });
}
